import React, { useRef, useState } from 'react';
import { StyleSheet } from 'react-native';
import { Box, Text, Image, Heading, Button, FormControl, Input, Pressable } from 'native-base';
import { createIconSetFromFontello } from 'react-native-vector-icons';
import AppContainer from '../Components/AppContainer';
import Trans from '../Components/Trans';

import main from '../../Assets/Styles/main.json';

import lineAwesomeConfig from '../../Assets/Fontello/line-awesome-config.json';
import APIAction from '../../Actions/APIAction';
import GeneralAction from '../../Actions/GeneralAction';

const Icon = createIconSetFromFontello(lineAwesomeConfig);

const mainStyle = StyleSheet.create({ ...main });

const LoginScreen = ({ navigation }) => {

    let [email, setEmail] = useState();
    let [password, setPassword] = useState();
    let [viewPassword, setViewPassword] = useState(false);
    let [invalid, setIvalid] = useState(false);
    let [loading, setLoading] = useState(false);

    let emailRef = useRef();
    let passwordRef = useRef();

    const submitLogin = async () => {
        setLoading(true);
        let result = await APIAction.login(email, password);
        setIvalid(!result);
        setLoading(false);
        if (!result) {
            GeneralAction.toast('error', <Trans>Wrong login credentials</Trans>);
        } else {
            navigation.reset({
                index: 0,
                routes: [{ name: 'Main' }],
            });
        }
    };

    const resetPassword = async () => {
        setLoading(true);
        navigation.navigate('ResetPasswordRequest');
    };

    return (
        <AppContainer
            noGradient
            noTabBar
            footer={
                <Box style={mainStyle.registrationAction}>
                    <Box mb={3} style={{ width: '100%' }}>
                        <Button
                            style={{ backgroundColor: "#00aaff", borderRadius: 10, width: '100%' }}
                            isLoading={loading}
                            isDisabled={loading}
                            onPress={submitLogin}
                        >
                            <Text style={{ color: '#fff', fontWeight: "600", fontSize: 17, textAlign: 'center', padding: 10 }}><Trans>Log in</Trans></Text>
                        </Button>
                    </Box>
                    <Box style={{ width: '100%' }}>
                        <Button
                            style={{ backgroundColor: "#00aaff", borderRadius: 10, width: '100%' }}
                            isLoading={loading}
                            isDisabled={loading}
                            onPress={resetPassword}
                        >
                            <Text style={{ color: '#fff', fontWeight: "600", fontSize: 17, textAlign: 'center', padding: 10 }}><Trans>Reset password</Trans></Text>
                        </Button>
                    </Box>
                </Box>
            }
        >
            {/* Header */}
            <Box style={mainStyle.headerJoin}>
                <Image
                    source={require('../../Assets/Images/logo.png')}
                    height={20}
                    width={40}
                    resizeMode={'contain'}
                />
            </Box>

            {/* Content */}
            <Box style={mainStyle.contentWrapperJoin}>
                <Heading style={{ color: '#000', fontWeight: '500', lineHeight: 36, textAlign: 'center', fontSize: 28 }}><Trans>Log in</Trans></Heading>
                <Heading style={{ color: '#00aaff', fontWeight: '700', lineHeight: 36, textAlign: 'center', fontSize: 28 }}><Trans>in Skedle</Trans></Heading>
                <Box style={{ width: '100%', maxWidth: 500 }}>
                    <Box style={{ width: '100%', maxWidth: '100%' }} mt="2">
                        <FormControl isRequired isInvalid={invalid}>
                            <FormControl.Label><Text><Trans>Email:</Trans></Text></FormControl.Label>
                            <Input
                                ref={emailRef}
                                type={'text'}
                                variant={'filled'}
                                autoCapitalize={'none'}
                                autoCorrect={false}
                                autoComplete={'email'}
                                returnKeyType={'next'}
                                keyboardType={'email-address'}
                                onChangeText={(text) => {
                                    setEmail(text.trim().toLocaleLowerCase());
                                }}
                                onSubmitEditing={() => {
                                    passwordRef.current.focus();
                                }}
                            />
                        </FormControl>
                    </Box>
                    <Box style={{ width: '100%', maxWidth: '100%' }} mt="2">
                        <FormControl isRequired isInvalid={invalid}>
                            <FormControl.Label><Text><Trans>Password:</Trans></Text></FormControl.Label>
                            <Input
                                ref={passwordRef}
                                type={viewPassword ? 'text' : 'password'}
                                variant={'filled'}
                                autoCapitalize={'none'}
                                autoCorrect={false}
                                autoComplete={'password'}
                                returnKeyType={'done'}
                                keyboardType={'default'}
                                secureTextEntry={!viewPassword}
                                onChangeText={(text) => {
                                    setPassword(text);
                                }}
                                InputRightElement={
                                    <Pressable
                                        onPress={() => {
                                            setViewPassword(!viewPassword);
                                        }}
                                    >
                                        <Icon name={viewPassword ? 'eye-slash' : 'eye'} size={16} style={{ marginRight: 5 }} />
                                    </Pressable>
                                }
                                onSubmitEditing={submitLogin}
                            />
                        </FormControl>
                    </Box>
                </Box>
            </Box>
        </AppContainer>
    );
}

export default LoginScreen;